module.exports = __webpack_public_path__ + "img/exit_8.86edec72.svg";